import TxtType from './lib/txtType';

const init = () => {
    const elements = document.querySelectorAll('.typewrite');

    elements.forEach((element) => {
        const toRotate = element.dataset.type;
        const { period } = element.dataset;

        if (!period || !toRotate) return;

        // eslint-disable-next-line no-new
        new TxtType(element, JSON.parse(toRotate), period);
    });
};

export default { init };
